import { useEffect, useState } from "react";
import { budApi } from "@/lib/api";

const FALLBACK = [
  { key: "stoner", label: "Stoner Bud", tagline: "Couch-locked, hella opinionated.", voice: "onyx" },
  { key: "sommelier", label: "Sommelier Bud", tagline: "Calm, refined, terpene-poetic.", voice: "echo" },
  { key: "hype", label: "Hype Bud", tagline: "All caps, all energy.", voice: "nova" },
  { key: "granny", label: "Granny Bud", tagline: "Wise, grandma-from-Humboldt.", voice: "shimmer" },
  { key: "surfer", label: "Surfer Bud", tagline: "Salt-laced, slow-mo.", voice: "fable" },
];

const TONE = ["card-green", "card-magenta", "card-cyan", "card-purple", "card-sunset"];

/**
 * Inline personality picker — chip row.
 * Persists pick in localStorage. Returns the selected key + voice via onChange.
 */
export default function BudPersonalityPicker({ value, onChange }) {
  const [list, setList] = useState(FALLBACK);

  useEffect(() => {
    budApi.personalities().then((r) => {
      if (r?.personalities?.length) setList(r.personalities);
    }).catch(() => {});
  }, []);

  return (
    <div className="flex flex-wrap gap-2" data-testid="bud-personality-row">
      {list.map((p, i) => {
        const active = value === p.key;
        return (
          <button
            key={p.key}
            data-testid={`personality-${p.key}`}
            onClick={() => onChange?.(p)}
            title={p.tagline}
            className={`px-3 py-1.5 rounded-full border-2 border-[#0B0F0C] text-[10px] font-mono-x font-bold uppercase tracking-widest transition-all ${active ? `${TONE[i % TONE.length]} bg-[#FFE74C] shadow-[3px_3px_0_#0B0F0C]` : "bg-[#FAF6E8] hover:bg-[#FFE74C]/40"}`}
          >
            {p.label}
          </button>
        );
      })}
    </div>
  );
}
